module.exports = __webpack_public_path__ + "static/media/minus-octagon.d4152e9d.svg";